export default function Terms() {
    return (
        <div data-testid="terms-page" className="pt-32 pb-24 mx-auto max-w-[900px] px-6 lg:px-10">
            <span className="text-[11px] uppercase tracking-[0.2em] font-bold text-[#FFD400]">Legal</span>
            <h1 className="mt-2 font-display text-5xl sm:text-6xl font-black tracking-tight">Terms &amp; Conditions</h1>
            <p className="mt-3 text-sm text-white/50">Effective Date: July 20, 2026</p>

            <div className="mt-10 space-y-8 text-white/75 leading-relaxed">
                <p>
                    Welcome to <span className="text-white font-semibold">APNI DUKAN TV</span>. By accessing or using this website, you agree to the following Terms &amp; Conditions.
                </p>

                <Section title="1. Acceptance of Terms">
                    <p>
                        By using APNI DUKAN TV, you agree to comply with these Terms. If you do not agree, please discontinue use of the website.
                    </p>
                </Section>

                <Section title="2. About APNI DUKAN TV">
                    <p>APNI DUKAN TV is an online streaming platform that showcases:</p>
                    <ul className="mt-2 list-disc list-inside space-y-1 text-white/70">
                        <li>AI-generated entertainment</li>
                        <li>AI commercials</li>
                        <li>Web series</li>
                        <li>Educational content</li>
                        <li>Creative storytelling</li>
                        <li>AI visual productions</li>
                    </ul>
                    <p className="mt-3">Content may be added, updated, or removed without prior notice.</p>
                </Section>

                <Section title="3. Intellectual Property">
                    <p>Unless otherwise stated, all content on APNI DUKAN TV, including but not limited to:</p>
                    <ul className="mt-2 list-disc list-inside space-y-1 text-white/70">
                        <li>Videos</li>
                        <li>Images</li>
                        <li>Graphics</li>
                        <li>Logos</li>
                        <li>Website design</li>
                        <li>Branding</li>
                        <li>AI-generated content</li>
                        <li>Text and media</li>
                    </ul>
                    <p className="mt-3">
                        is the intellectual property of APNI DUKAN and is protected by applicable copyright and intellectual property laws.
                        No content may be copied, reproduced, distributed, or used commercially without prior written permission.
                    </p>
                </Section>

                <Section title="4. Acceptable Use">
                    <p>You agree not to:</p>
                    <ul className="mt-2 list-disc list-inside space-y-1 text-white/70">
                        <li>Copy or redistribute content without authorization.</li>
                        <li>Attempt to interfere with the website's operation or security.</li>
                        <li>Use the platform for unlawful purposes.</li>
                        <li>Misrepresent ownership of any content available on the platform.</li>
                    </ul>
                </Section>

                <Section title="5. Third-Party Links">
                    <p>
                        The website may contain links to third-party websites or services. APNI DUKAN is not responsible for the content, policies, or practices of those external websites.
                    </p>
                </Section>

                <Section title="6. Disclaimer">
                    <p>
                        All content on APNI DUKAN TV is provided for entertainment, educational, and informational purposes.
                        The website is provided on an "as is" and "as available" basis without warranties of any kind.
                    </p>
                </Section>

                <Section title="7. Limitation of Liability">
                    <p>
                        APNI DUKAN shall not be liable for any direct, indirect, incidental, or consequential damages resulting from the use of this website or its content.
                    </p>
                </Section>

                <Section title="8. Changes to These Terms">
                    <p>
                        We reserve the right to modify these Terms &amp; Conditions at any time. Continued use of the website after changes are posted constitutes acceptance of the updated Terms.
                    </p>
                </Section>

                <Section title="9. Governing Law">
                    <p>
                        These Terms &amp; Conditions shall be governed by the laws of India.
                    </p>
                </Section>

                <Section title="10. Contact Us">
                    <p>For any questions regarding these Terms &amp; Conditions, please contact:</p>
                    <p className="mt-3">
                        <span className="text-white font-semibold">APNI DUKAN</span><br />
                        Email:{" "}
                        <a href="mailto:linkan@yourapnidukan.com" className="text-[#FFD400] hover:underline">
                            linkan@yourapnidukan.com
                        </a>
                    </p>
                </Section>
            </div>
        </div>
    );
}

function Section({ title, children }) {
    return (
        <section>
            <h2 className="font-display font-bold text-2xl text-white mb-3">{title}</h2>
            <div className="text-white/75">{children}</div>
        </section>
    );
}
